import { Button, Space, Tag, Tooltip } from "antd"
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  EyeOutlined,
} from "@ant-design/icons"

function formatMoney(val) {
  if (val == null) return "—"
  return Number(val).toLocaleString("ru-RU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function getColumns(onView, onSendPrepayment, onSendFullPayment) {
  return [
    {
      title: "ID заказа",
      dataIndex: "id",
      key: "id",
      width: 90,
      sorter: true,
    },
    {
      title: "Внутр. номер",
      dataIndex: "innerId",
      key: "innerId",
      width: 120,
      sorter: true,
    },
    {
      title: "Статус",
      dataIndex: "orderStatus",
      key: "orderStatus",
      width: 120,
    },
    {
      title: "Оплата",
      dataIndex: "paymentType",
      key: "paymentType",
      width: 100,
    },
    {
      title: "Юр. лицо",
      dataIndex: "paymentAccountName",
      key: "paymentAccountName",
      width: 160,
      sorter: true,
      render: (val) => val ?? "—",
    },
    {
      title: "Точка",
      dataIndex: "pointShortName",
      key: "pointShortName",
      width: 140,
      render: (val) => val ?? "—",
    },
    {
      title: "Сумма заказа",
      dataIndex: "totalPriceWithDiscount",
      key: "totalPriceWithDiscount",
      width: 110,
      sorter: true,
      render: (val, record) => formatMoney(val ?? record.totalPrice),
    },
    {
      title: "Сумма по чекам",
      dataIndex: "sumOnOfd",
      key: "sumOnOfd",
      width: 130,
      render: (val) => formatMoney(val),
    },
    {
      title: "Сумма возврата",
      dataIndex: "refusedSum",
      key: "refusedSum",
      width: 130,
      render: (val) => (
        <span style={{ color: val ? "#cf1322" : undefined }}>
          {formatMoney(val)}
        </span>
      ),
    },
    {
      title: "Дата доставки",
      dataIndex: "deliveryDate",
      key: "deliveryDate",
      width: 140,
      sorter: true,
    },
    {
      title: "Маркировка",
      dataIndex: "hasMarkProducts",
      key: "hasMarkProducts",
      width: 110,
      align: "center",
      sorter: true,
      render: (val) =>
        val ? <Tag color="blue">Да</Tag> : <Tag>Нет</Tag>,
    },
    {
      title: "Чек предоплаты",
      key: "receiptFirst",
      width: 130,
      align: "center",
      render: (_, record) => {
        if (record.receiptFirstConfirm) {
          return (
            <Tag color="green" icon={<CheckCircleOutlined />}>
              Отправлен
            </Tag>
          )
        }
        return (
          <Tag color="orange" icon={<CloseCircleOutlined />}>
            Не отправлен
          </Tag>
        )
      },
    },
    {
      title: "Чек полной оплаты",
      key: "receiptSecond",
      width: 140,
      align: "center",
      render: (_, record) => {
        if (record.receiptSecondConfirm) {
          return (
            <Tag color="green" icon={<CheckCircleOutlined />}>
              Отправлен
            </Tag>
          )
        }
        return (
          <Tag color="orange" icon={<CloseCircleOutlined />}>
            Не отправлен
          </Tag>
        )
      },
    },
    {
      title: "Действие",
      key: "action",
      width: 160,
      fixed: "right",
      render: (_, record) => (
        <Space size="small" wrap>
          <Tooltip title="Подробнее">
            <Button
              size="small"
              type="link"
              onClick={() => onView(record.id)}
              icon={<EyeOutlined />}
            />
          </Tooltip>
          {onSendPrepayment && !record.receiptFirstConfirm && (
            <Tooltip title="Отправить чек предоплаты">
              <Button
                size="small"
                type="primary"
                ghost
                onClick={() => onSendPrepayment(record.id)}
              >
                Предоплата
              </Button>
            </Tooltip>
          )}
          {onSendFullPayment && !record.receiptSecondConfirm && (
            <Tooltip title="Отправить полный чек">
              <Button
                size="small"
                type="primary"
                ghost
                onClick={() => onSendFullPayment(record.id)}
              >
                Полная
              </Button>
            </Tooltip>
          )}
        </Space>
      ),
    },
  ]
}
